/*
  Tabbed Content — click a tab label to swap the body text/button AND the
  image/video on the other side. Sequential fade only (fade the current
  panel/media fully out, then fade the new one in) — never overlapping, so
  two different images never blend into each other mid-transition.
*/
function debounce(fn, wait) {
  var timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(fn, wait);
  };
}

function initTabbedContent() {
  document.querySelectorAll('[data-tabbed-content]').forEach(function (root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-tab-trigger]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tab-panel]'));
    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-tab-media]'));
    var panelsContainer = root.querySelector('.tabbed-content-panels');
    if (!triggers.length || !panels.length) return;

    var FADE_MS = 350;
    var activeIndex = 0;
    triggers.forEach(function (trigger) {
      if (trigger.classList.contains('is-active')) {
        activeIndex = parseInt(trigger.getAttribute('data-tab-index'), 10);
      }
    });
    var transitioning = false;

    // Measure the tallest panel once so switching between differently
    // sized text blocks never causes the section to jump in height.
    function measureHeights() {
      var maxHeight = 0;
      panels.forEach(function (panel) {
        var wasActive = panel.classList.contains('is-active');
        if (!wasActive) {
          panel.style.position = 'static';
          panel.style.opacity = '0';
          panel.style.visibility = 'hidden';
        }
        maxHeight = Math.max(maxHeight, panel.offsetHeight);
        if (!wasActive) {
          panel.style.position = '';
          panel.style.opacity = '';
          panel.style.visibility = '';
        }
      });
      if (panelsContainer && maxHeight > 0) {
        panelsContainer.style.minHeight = maxHeight + 'px';
      }
    }
    measureHeights();
    window.addEventListener('resize', debounce(measureHeights, 200));

    function goToTab(targetIndex) {
      if (transitioning || targetIndex === activeIndex) return;
      transitioning = true;

      triggers.forEach(function (trigger) {
        var idx = parseInt(trigger.getAttribute('data-tab-index'), 10);
        trigger.classList.toggle('is-active', idx === targetIndex);
        trigger.setAttribute('aria-selected', idx === targetIndex ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        if (parseInt(panel.getAttribute('data-tab-index'), 10) === activeIndex) {
          panel.classList.remove('is-active');
        }
      });
      mediaItems.forEach(function (media) {
        if (parseInt(media.getAttribute('data-tab-index'), 10) === activeIndex) {
          media.classList.remove('is-active');
        }
      });

      setTimeout(function () {
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', parseInt(panel.getAttribute('data-tab-index'), 10) === targetIndex);
        });
        mediaItems.forEach(function (media) {
          media.classList.toggle('is-active', parseInt(media.getAttribute('data-tab-index'), 10) === targetIndex);
        });
        activeIndex = targetIndex;
        transitioning = false;
      }, FADE_MS);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        goToTab(parseInt(trigger.getAttribute('data-tab-index'), 10));
      });
    });
  });
}

if (document.readyState === 'complete') {
  initTabbedContent();
} else {
  window.addEventListener('load', initTabbedContent);
}
